import React from "react";
import PropTypes from "prop-types";

import withStyles from '@mui/styles/withStyles';

import QualificationComponent from './QualificationComponent';
import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';

import Checkbox from '@mui/material/Checkbox';

import FormControlLabel from '@mui/material/FormControlLabel';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import QualificationAccordionSummary from './QualificationAccordionSummary';

import QualificationTextField from 'components/Shared/QualificationTextField';

import { GarantieType } from 'constants.js';


const styles = theme => ({
    row: {
        flexBasis: '100%',
        marginBottom: '10px'
    },

    formControl: {
        margin: theme.spacing(1)
    },

    group: {
        margin: theme.spacing(1, 0)
    },
});

class PriseEnCharge extends QualificationComponent {


    constructor(props) {
        super(props);


        this.state = {
            ...this.state,

            nbBatterie: 0,
            nbChargeur: 0,
            nbSystainer: 0,
            nbMandrin: 0,
            autres: '',
            aucune: false,
            commentaires: '',
        };

        this.generableCodes = [

            ReclamationQualificationDetailCodes.DetailSavRestitutionNbBatterie,
            ReclamationQualificationDetailCodes.DetailSavRestitutionNbChargeur,
            ReclamationQualificationDetailCodes.DetailSavRestitutionNbSystainer,
            ReclamationQualificationDetailCodes.DetailSavRestitutionNbMandrin,
            ReclamationQualificationDetailCodes.DetailSavRestitutionAucune,
            ReclamationQualificationDetailCodes.DetailSavRestitutionAutres,
            ReclamationQualificationDetailCodes.DetailSavCommentaires
        ];
    }


    componentDidMount() {
        const { name } = this.props;
        const { position, toAdd, toDelete } = this.getQualificationData(this.state);

        this.props.onChange(name, position, toAdd, toDelete, "Mount");
    }



    handleChangeAucuneRestitution = (event) => {
        const { onChange, name } = this.props;

        let newState =
        {
            ...this.state,
            [event.target.name]: event.target.value,
            nbBatterie: 0,
            nbChargeur: 0,
            nbSystainer: 0,
            nbMandrin: 0,
            autres: '',
        };
        this.setState(newState);

        const { position, toAdd, toDelete } = this.getQualificationData(newState);

        onChange(name, position, toAdd, toDelete, "Life");
    }


    getQualificationData(newState) {
        const { name } = this.props;

        // Préparation des codes à supprimer (tous les codes générables)
        let toDelete = [...this.generableCodes];

        let toAdd = [];

        toAdd.push({
            //position: toAdd.length,
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavRestitutionAucune,
            type: ReclamationQualificationDetailType.Booleen,
            libelle: "Aucune restitution d'accessoires.",
            valeurBool: newState.aucune
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavRestitutionAucune);

        if (!newState.aucune) {

            toAdd.push({
                //position: toAdd.length,
                position: 0,
                code: ReclamationQualificationDetailCodes.DetailSavRestitutionNbBatterie,
                type: ReclamationQualificationDetailType.Nombre,
                libelle: "Batterie",
                valeurInteger: newState.nbBatterie
            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavRestitutionNbBatterie);

            toAdd.push({
                //position: toAdd.length,
                position: 0,
                code: ReclamationQualificationDetailCodes.DetailSavRestitutionNbChargeur,
                type: ReclamationQualificationDetailType.Nombre,
                libelle: "Chargeur",
                valeurInteger: newState.nbChargeur
            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavRestitutionNbChargeur);

            toAdd.push({
                //position: toAdd.length,
                position: 0,
                code: ReclamationQualificationDetailCodes.DetailSavRestitutionNbSystainer,
                type: ReclamationQualificationDetailType.Nombre,
                libelle: "Systainer",
                valeurInteger: newState.nbSystainer
            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavRestitutionNbSystainer);

            toAdd.push({
                //position: toAdd.length,
                position: 0,
                code: ReclamationQualificationDetailCodes.DetailSavRestitutionNbMandrin,
                type: ReclamationQualificationDetailType.Nombre,
                libelle: "Mandrin",
                valeurInteger: newState.nbMandrin
            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavRestitutionNbMandrin);



            toAdd.push({
                //position: toAdd.length,
                position: 0,
                code: ReclamationQualificationDetailCodes.DetailSavRestitutionAutres,
                type: ReclamationQualificationDetailType.Texte,
                libelle: "Autres accessoires",
                valeurString: newState.autres
            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavRestitutionAutres);

        }

        toAdd.push({
            //position: toAdd.length,
            position: 0,
            code: ReclamationQualificationDetailCodes.DetailSavCommentaires,
            type: ReclamationQualificationDetailType.Texte,
            libelle: "Commentaires",
            valeurString: newState.commentaires
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.DetailSavCommentaires);


        return {
            name: name,
            position: this.props.position,
            toAdd: toAdd,
            toDelete: toDelete
        }
    }




    render() {
        const { name } = this.props;


        const { nbBatterie, nbChargeur, nbSystainer, nbMandrin, autres, aucune } = this.state;
        const { commentaires } = this.state;


        return (


            <Accordion id={name} defaultExpanded={true} elevation={3}>

                <QualificationAccordionSummary title="Restitution d'accessoires" />


                <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>



                    <FormControlLabel
                        control={
                            <Checkbox checked={aucune === true} onChange={e => this.handleChangeAucuneRestitution({ target: { name: "aucune", value: aucune === '' ? true : !aucune } })} value="true" />
                        }
                        label={"Aucune restitution d'accessoires"}
                    />

                    {aucune === false && (

                        <>

                            <QualificationTextField
                                label={"Batterie"}
                                name={"nbBatterie"}
                                value={nbBatterie}
                                onChange={this.handleChange}
                                type="number"
                                inputProps={{ min: 0 }}
                                disabled={aucune === true}
                            />

                            <QualificationTextField
                                label={"Chargeur"}
                                name={"nbChargeur"}
                                value={nbChargeur}
                                onChange={this.handleChange}
                                type="number"
                                inputProps={{ min: 0 }}
                                disabled={aucune === true}
                            />

                            <QualificationTextField
                                label={"Systainer"}
                                name={"nbSystainer"}
                                value={nbSystainer}
                                onChange={this.handleChange}
                                type="number"
                                inputProps={{ min: 0 }}
                                disabled={aucune === true}
                            />

                            <QualificationTextField
                                label={"Mandrin"}
                                name={"nbMandrin"}
                                value={nbMandrin}
                                onChange={this.handleChange}
                                type="number"
                                inputProps={{ min: 0 }}
                                disabled={aucune === true}
                            />





                            <QualificationTextField
                                label={"Autres accessoires"}
                                name={"autres"}
                                value={autres}
                                onChange={this.handleChange}
                                disabled={aucune === true}
                            />
                        </>

                    )}



                    <QualificationTextField
                        label={"Commentaires"}
                        name={"commentaires"}
                        value={commentaires}
                        onChange={this.handleChange}
                        multiline
                    />


                </AccordionDetails>
            </Accordion>

        );
    }

}


PriseEnCharge.propTypes = {
    name: PropTypes.string.isRequired,
    garantie: PropTypes.number,
    renvoiRequis: PropTypes.bool,
    adresseRenvoi: PropTypes.object,


    designation: PropTypes.string,
    codeArticle: PropTypes.string,
    fournisseurCode: PropTypes.string,
};

PriseEnCharge.defaultProps = {
    garantie: GarantieType.SousGarantieApresUtilisation
};

export default withStyles(styles)(PriseEnCharge);